// extracted by mini-css-extract-plugin
export default {"iconGallery":"pQfLYad","iconLabel":"tfBb9jz"};